import {
  VIEW_PEOPLE_RISK_METRICS,
  VIEW_PERSONS,
  VIEW_REPORTS,
  VIEW_TRIP_EMAIL_PARSING_REPORTS,
  VIEW_TRIPS,
} from './permissions';

export const REPORTS_DATA = {
  '7bc7420e-a30f-4882-bef8-f2d69fb5575c': {
    // Address data quality
    filters: {
      organizationIds: {
        requirePermissions: [],
      },
    },
  },
  '37abd84e-bf65-4f02-8708-2ddecb709cfb': {
    // Ppl risk mgmt alert notif prefs
    filters: {
      organizationIds: {
        requirePermissions: [VIEW_PEOPLE_RISK_METRICS],
      },
      locationIds: {},
      alertSeverities: {},
      alertCategories: {},
      modalities: {},
      roles: {},
      preferenceStatus: {},
    },
  },
  '1f66cf87-ffe5-4fc8-835e-4f60fcceb70b': {
    // Ppl risk mgmt alert notif usage
    filters: {
      organizationIds: {
        requirePermissions: [VIEW_PEOPLE_RISK_METRICS],
      },
      locationIds: {},
      dateRange: {},
      alertSeverities: {},
      alertCategories: {},
      modalities: {},
      roles: {},
      preferenceStatus: {},
    },
  },
  '10159b89-8efa-425a-9bbc-8bd4b8fb7aa7': {
    // Email Parsing
    filters: {
      organizationIds: {
        infoMessageId: 'emailParsingOrganizationIdsInfo',
        requirePermissions: [VIEW_TRIP_EMAIL_PARSING_REPORTS],
      },
      dateRange: {},
      emailId: {},
      fromEmail: {},
      toEmail: {},
      ccEmail: {},
      userEmail: {},
      emailSubject: {},
      recordLocator: {},
      pnrItineraryId: {},
      parsingStatus: {},
    },
  },
  '637d159a-9e5c-4cda-9542-dc55a7022e07': {
    // Travel Activity
    filters: {
      organizationIds: {
        infoMessageId: 'travelActivityOrganizationIdsInfo',
        requirePermissions: [VIEW_REPORTS, VIEW_PEOPLE_RISK_METRICS, VIEW_PERSONS, VIEW_TRIPS],
      },
      tripBookingStatus: {
        infoMessageId: 'travelActivityTripBookingStatusInfo',
      },
      profileStatus: {
        infoMessageId: 'travelActivityProfileStatusInfo',
      },
      destinationType: {
        infoMessageId: 'travelActivityDestinationTypeInfo',
      },
      includeDeletedTrips: {
        infoMessageId: 'travelActivityIncludeDeletedTripsInfo',
      },
      includeDeletedPeople: {
        infoMessageId: 'travelActivityIncludeDeletedPeopleInfo',
      },
      tripDateRangeOptions: {
        infoMessageId: 'travelActivityTripDateRangeOptionsInfo',
      },
    },
  },
};

export const SCHEDULE_DTO_ENUM = {
  scheduleName: 'scheduleName',
  frequencyOfDelivery: 'frequencyOfDelivery',
  deliveryMode: 'deliveryMode',
  recipientType: 'recipientType',
  organizationId: 'organizationId',
  toOrganizationRecipientIds: 'toOrganizationRecipientIds',
  exportOptions: 'exportOptions',
  startDate: 'startDate',
  endDate: 'endDate',
  runAtTime: 'runAtTime',
  frequencyType: 'frequencyType',
  repeatDailyInterval: 'repeatDailyInterval',
  daysOfWeek: 'daysOfWeek',
  repeatMonthlyInterval: 'repeatMonthlyInterval',
  daysOfMonth: 'daysOfMonth',
  contentType: 'contentType',
  sftpConfigId: 'sftpConfigId',
  sftpConfigName: 'sftpConfigName',
  exportFileNameTemplate: 'exportFileNameTemplate',
};

export const RECIPIENT_TYPE = {
  USER: 'USER',
  ORGANIZATION_RECIPIENT: 'ORGANIZATION_RECIPIENT',
  SFTP: 'SFTP',
};

export const FREQUENCY_TYPE_VALUES = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
};

export const DELIVERY_MODE_VALUES = {
  XLSX: 'XLSX',
  LINK: 'LINK',
  CSV: 'CSV',
};

export const DAYS_OF_WEEK_VALUES = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
};

export const USER_SCHEDULE_FILTER_KEY = 'userScheduleFilterValues';

export const USER_SCHEDULE_FILTER_TYPES = {
  DATETIME_RANGE: 'DATETIME_RANGE',
  CSAR_RATING_RANGE: 'CSAR_RATING_RANGE',
  LOCATION: 'LOCATION',
  CATEGORY: 'CATEGORY',
  ORGANIZATION: 'ORGANIZATION',
  ORGANIZATION_V2: 'ORGANIZATION_V2',
  ENUM: 'ENUM',
  PERSON_LOCATION_TYPE: 'PERSON_LOCATION_TYPE',
  PERSON_TYPE_V2: 'PERSON_TYPE_V2',
  BOOLEAN: 'BOOLEAN',
  KEYWORD: 'KEYWORD',
  SITE_TYPE: 'SITE_TYPE',
  MULTI_DATETIME_RANGE: 'MULTI_DATETIME_RANGE',
  PERSON_TYPE: 'PERSON_TYPE',
  LANGUAGE: 'LANGUAGE',
  FETCH_DATA: 'FETCH_DATA',
  INTEGER: 'INTEGER',
  CSAR_RATING_RANGE_V2: 'CSAR_RATING_RANGE_V2',
  TEXT: 'TEXT',
};

export const DYNAMIC_FILTER_STORAGE_KEYS = {
  DATE_RANGE_START_VALUE: 'dateRangeStartValue',
  DATE_RANGE_END_VALUE: 'dateRangeEndValue',
  CSAR_RANGE_START_VALUE: 'csarRangeStartValue',
  CSAR_RANGE_END_VALUE: 'csarRangeEndValue',
  OR_LOCATION_IDS: 'orLocationIds',
  ORGANIZATION_IDS: 'organizationIds',
  PERSON_LOCATION_TYPES: 'personLocationTypes',
};

export const FETCH_DATA_TYPE = {
  E_LEARNING_COURSE: 'E_LEARNING_COURSE',
  E_LEARNING_MODULE: 'E_LEARNING_MODULE',
  USER_ROLES: 'USER_ROLES',
};

export const REPORT_COMPLEXITY = {
  SIMPLE: 'COMMUNICATIONS_SIMPLE',
  DETAILED: 'COMMUNICATIONS_DETAILED',
};

export const REPORT_RATINGS_DEFAULT_RANGE = [1, 5];
